module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/15124c8f39b68da5419c0104b3d35027.png";